export default __webpack_public_path__ + "static/credit-card-payment-46c50a8cfa25be17cccc96c7b6d720bf.png";